export const langTimeSpeedChart = {
  fr: {
    distanceChartTitle: '% distance parcourue par classe de vitesse (knt)',
    timeChartTitle: '% temps session par classe de vitesse (knt)',
  },

  eng: {
    distanceChartTitle: '% distance covered by speed class (knt)',
    timeChartTitle: '% time session by speed class (knt)',
  },
}
